import { render } from "./MoreCommentsButtons.vue?vue&type=template&id=b8cc7960&scoped=true"
import script from "./MoreCommentsButtons.vue?vue&type=script&lang=js"
export * from "./MoreCommentsButtons.vue?vue&type=script&lang=js"

import "./MoreCommentsButtons.vue?vue&type=style&index=0&id=b8cc7960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8cc7960"]])

export default __exports__